<template>
  <div :class="`a-loading-secondary ${loadingClass}`">
    <p>Cargando Datos...</p>
  </div>
</template>

<script>
export default {
  name: 'AtomLoadingSecondary',

  props: {
    loadingClass: String
  }
}
</script>
